const defaultConfig = {

};

export default class MapModel {
    constructor(regionModel, options) {
        this.regionModel = regionModel;
        this.options = {
            ...defaultConfig,
            ...options
        };
    }

    get currentRegion() {
        return this.regionModel.region;
    }

    get compareMapGeojson() {
        if (!this.regionModel.lgaGeojson) {
            return this.regionModel.lgaGeojson;
        }

        if (!this.currentRegion) {
            return null;
        }

        return this.regionModel.lgaGeojson;
    }

    get highlightMapGeojson() {
        if (!this.regionModel.lgaGeojson) {
            return this.regionModel.lgaGeojson;
        }
        if (!this.currentRegion) {
            return null;
        }
        return {
            ...this.regionModel.lgaGeojson,
            features: [this.regionModel.lgaGeojson.features.find(({ properties: { LOCAL_CODE: localCode } }) => localCode === this.currentRegion.localCode)]
                .map(feature => ({ ...feature, properties: {} }))
        };
    }

    get pointsOfInterest() {
        return this.regionModel.localMunicipalities.map(({ name, labelPosition, lat, lng }) => ({
            label: name,
            labelPosition,
            lat,
            lng
        }));
    }
}
